import { BaseModel } from "../BaseModel";
import { BaseFindResult } from "../BaseFindResult";
import { TherapistEventModel } from "./TherapistEventModel";

export class TherapistEventFindResultModel extends BaseFindResult {

    public getDataItem(i: number): TherapistEventModel {
        let o: TherapistEventModel = Object.assign(new TherapistEventModel(), this.data[i]);
        return o;
    }

    public get dataTyped(): TherapistEventModel[] {

        let d: TherapistEventModel[] = [];

        for (var i = 0; i < this.data.length; i++) {
            d.push(this.getDataItem(i));
        }
        return d;
    }

    public override assignObjects(): void {
        super.assignObjects();

        for (var i = 0; i < this.data.length; i++) {
            let o: TherapistEventModel = Object.assign(new TherapistEventModel(), this.data[i]);
            this.data[i] = o;
        }
    }

}
